__turbopack_context__.v({
  "className": "fira_code_58addc89-module__OKVtFa__className",
  "variable": "fira_code_58addc89-module__OKVtFa__variable",
});
